import axios, { AxiosRequestConfig } from 'axios';

// Constants
import ENVIRONMENTS from 'constants/enviroments';

// Helpers

// Actions

// Store

const apiBase = axios.create({
  baseURL: ENVIRONMENTS.API_DIGITAL_TICKET.ITINERARY_CAPACITY_API,
});

const callApiBase = (
  call: AxiosRequestConfig & {
    endpoint: string;
    method: AxiosRequestConfig;
    useToken: boolean;
    params?: {};
    data?: any;
    formData?: FormData;
    headers?: {};
    showJSON?: boolean;
    showConsoleLog?: boolean;
    title?: string;
  },
) => {
  const {
    endpoint,
    method = 'GET',
    useToken = false,
    params = {},
    data = {},
    formData,
    responseType = '',
  } = call;

  return apiBase(endpoint, {
    params: {
      ...params,
    },
    method,
  });
};

export default callApiBase;
